import * as Api from '../../../weborder/Api';

type CheckoutButtonStateType = {
  buttonLabel: string;
  isCheckoutEnabled: boolean;
};

export const checkIsOutsideDeliveryZone = (
  restaurant: Api.DeliveryRestaurantDetail | Api.CollectionRestaurantDetail,
): boolean =>
  restaurant?.DeliveryType === Api.DeliveryType.Delivery &&
  restaurant?.UserOutsideDeliveryZone;

const getAriaLabel = (
  name: string,
  description: string,
  from: boolean,
  currencySymbol: string,
  translate: any,
): string =>
  `${name}, ${description} ${from && translate('From')} ${currencySymbol}`;

const getButtonState = (
  acceptPreOrders: boolean,
  isDeliveryOrder: boolean,
  isOutsideDeliveryZone: boolean,
  isOpen: boolean,
  translate: any,
): CheckoutButtonStateType => {
  if (isDeliveryOrder && isOutsideDeliveryZone) {
    return {
      buttonLabel: translate('Cannot_deliver_checkout'),
      isCheckoutEnabled: false,
    };
  }

  if (isOpen) {
    return {
      buttonLabel: translate('Checkout'),
      isCheckoutEnabled: true,
    };
  }

  if (acceptPreOrders) {
    return {
      buttonLabel: translate('Preorder'),
      isCheckoutEnabled: true,
    };
  }

  return {
    buttonLabel: translate('Closed'),
    isCheckoutEnabled: false,
  };
};

export const restaurantMenuUtils = {
  getAriaLabel,
  getButtonState,
};
